import { useContext, useEffect } from "react";
import { useState } from "react";
import { createContext } from "react";
import { Outlet } from "react-router-dom";
import { apiJalles } from "../services/api";
import { toast } from "react-toastify";
import { HomeContext } from "./contexHome";

export const MotobombaContext = createContext({});

export const MotobombaProvider = () => {
  const token = sessionStorage.getItem("connectionsToken");
  const unit = sessionStorage.getItem("connectionsUnit");
  const [motobombaSalve, setMotobombaSalve] = useState([]);
  const [modalAlertaMotobomba, setModalAlertaMotobomba] = useState(false);
  const [alertasMotoBombas, setAlertasMotoBombas] = useState([]);
  const [modalConfimetionMotobomba, setModalConfimationMotobomba] =
    useState(false);
  const [funtionControleSave, setFuntionConoleSave] = useState([]);
  const [acleracaoList, setAceleracaoListe] = useState({});
  const [loading, setLoading] = useState(false);

  const { user } = useContext(HomeContext);

  const userLogado = user;

  const headerApi = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const listMotoBomba = async () => {
    try {
      const response = await apiJalles.get("motobombasjalles/", headerApi);
      setMotobombaSalve(response.data);
    } catch (error) {
    }
  };

  const alertaListMotobomba = async () => {
    try {
      const response = apiJalles.get("alertasmotobomba/", headerApi);
      setAlertasMotoBombas(response.data);
    } catch (error) {
    }
  };

  const motoBombaUpdate = async (data, id, user) => {
    try {
      if (!userLogado.is_superuser && !userLogado.is_staff) {
        throw new Error("Usuario não autorizado");
      }

      setLoading(true);
      const update = await apiJalles.patch(
        `motobombasjalles/${id}/`,
        data,
        headerApi
      );
      setMotobombaSalve((prevList) => {
        return prevList.map((item) =>
          item.id === id ? { ...item, ...update.data } : item
        );
      });
      toast.success("Comando Feito com sucesso", {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } catch (error) {
      if (error.message === "Usuario não autorizado") {
        toast.warn("😅Sem autorização para realizar esta ação", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else {
        toast.warn("😅Algo de Errado", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    } finally {
      setModalConfimationMotobomba(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    alertaListMotobomba();
  }, []);
  return (
    <MotobombaContext.Provider
      value={{
        motobombaSalve,
        modalAlertaMotobomba,
        setModalAlertaMotobomba,
        alertasMotoBombas,
        modalConfimetionMotobomba,
        setModalConfimationMotobomba,
        funtionControleSave,
        setFuntionConoleSave,
        motoBombaUpdate,
        acleracaoList,
        setAceleracaoListe,
        listMotoBomba,
        loading,
      }}
    >
      <Outlet />
    </MotobombaContext.Provider>
  );
};
